import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SubscriptionComparison } from 'src/app/core/models/subscription/subscription.model';
import { SUBSCRIPTION_COMPARISON } from 'src/app/core/constants/subscription.constants';

/**
 * SubscriptionComparisonComponent
 *
 * Displays a comparison table between Free and Game Master subscription tiers.
 * Shows features with checkmarks and X marks for availability.
 *
 * @example
 * <app-subscription-comparison
 *   [showUpgradeButton]="true"
 *   (upgrade)="onUpgrade()">
 * </app-subscription-comparison>
 */
@Component({
  selector: 'app-subscription-comparison',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './subscription-comparison.component.html',
  styleUrls: ['./subscription-comparison.component.scss'],
})
export class SubscriptionComparisonComponent {
  /**
   * Comparison data (tiers and features)
   * Defaults to the standard comparison from constants
   */
  @Input() data: SubscriptionComparison = SUBSCRIPTION_COMPARISON;

  /**
   * Whether to show the upgrade button at the bottom
   */
  @Input() showUpgradeButton = true;

  /**
   * Optional custom message to display at the top of the comparison
   * Used for feature-locked scenarios
   */
  @Input() customMessage?: string;

  /**
   * Emits when the upgrade button is clicked
   */
  @Output() upgrade = new EventEmitter<void>();

  /**
   * Handles the upgrade button click
   */
  onUpgrade(): void {
    this.upgrade.emit();
  }
}
